document.addEventListener("DOMContentLoaded", () => {
    const SCROLL_THRESHOLD = 1;

    const SELECTORS = {
        scope: ".site-navbar__menu",
        burger: ".site-navbar__menu .mobile_menu_bar",
        mobileMenus: ".site-navbar__menu ul.et_mobile_menu",
        mobileParentItem: "li.menu-item-has-children",
        controller: ".site-navbar-controller",
    };

    function enhanceBurger() {
        const burger = document.querySelector(SELECTORS.burger);
        if (!burger) return;

        // Prevent overwriting if already injected
        if (burger.querySelector(".line1")) return;

        burger.innerHTML = `
      <span class="line line1"></span>
      <span class="line line2"></span>
      <span class="line line3"></span>
    `;
    }

    function enhanceMobileMenu() {
        const menus = document.querySelectorAll(SELECTORS.mobileMenus);
        if (!menus.length) return;

        menus.forEach((menu) => {
            const parentItems = menu.querySelectorAll(SELECTORS.mobileParentItem);

            parentItems.forEach((item) => {
                // Prevent duplicates
                if (item.querySelector(":scope > .toggle-sub-menu")) return;

                const toggle = document.createElement("div");
                toggle.className = "toggle-sub-menu";
                item.appendChild(toggle);

                toggle.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const isOpen = item.classList.contains("is-open");

                    // close others within this menu
                    parentItems.forEach((el) => el.classList.remove("is-open"));

                    if (!isOpen) item.classList.add("is-open");
                });
            });

            // Open current menu parent by default
            menu.querySelectorAll(".current-menu-parent")
                .forEach((item) => item.classList.add("is-open"));
        });
    }

    function enhanceMobileToggle() {
        const burger = document.querySelector(SELECTORS.burger);
        if (!burger) return;

        burger.addEventListener("click", () => {
            document.body.classList.toggle("nav-is-open");

            // Divi sometimes updates DOM right after click → re-run
            window.setTimeout(() => {
                enhanceBurger();
                enhanceMobileMenu();
            }, 50);
        });
    }

    function enhanceScrollState() {
        const controller = document.querySelector(SELECTORS.controller);
        if (!controller) return;

        const onScroll = () => {
            controller.classList.toggle("is-scrolled", window.scrollY >= SCROLL_THRESHOLD);
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
    }

    // Init
    enhanceBurger();
    enhanceMobileMenu();
    enhanceMobileToggle();
    enhanceScrollState();

    // Safety: some themes load/replace menu after DOMContentLoaded
    window.setTimeout(enhanceMobileMenu, 250);
});
